export default "__VITE_ASSET__CGHi2q_K__"